<div class="border-l-4 border-primary bg-primary-50 p-2 mb-2 text-gray-900 relative rounded-md reply-message">
  @if(!reply){
    <p class="leading-6 break-words whitespace-pre-line">
      Messaggio non disponibile.
    </p>
  } @else {
    <app-message-renderer [message]="reply" [showAiInsights]="false" />
  }
</div>


